import { requestGet, requestPost, requestPut, requestDelete } from '../dva16'

// 注册码
export function getCode(payload) {
  console.log('payload', payload)
  return requestPost('captcha', payload)
}
// 注册
export function postRegist(payload) {
  return requestPost('user', payload)
}
//登录
export function postLogin(payload) {
  return requestPost('token', payload)
}

//游客登录
export function guestLogin() {
  return requestPost('guestLogin')
}
//修改密码
export function putUserPassword(payload) {
  return requestPut('userPassword', payload)
}

//微信登录二维码
export function getWechatCode(payload) {
  console.log('hahha qrcode')
  return { code: 1111 }
}

//微信登录状态
export function getLoginStatus(payload) {
  return payload
}

//微信绑定
export function bindWechat(payload) {
  return payload
}

/*------------------------------ 微信相关 ------------------------------*/
export function getWechatQrCode(payload) {
  return requestGet('wechat/qrCode', payload)
}
export function postTokenByWechat(payload) {
  return requestPost('tokenByWechat', payload)
}
export function postBindUserByWechat(payload) {
  return requestPost('bindUserByWechat', payload)
}

// 获取广场帖子列表
export function getInfo(payload) {
  return requestGet('info', payload)
}

// 获取帖子详情
export function getInfoDetail(payload) {
  return requestGet(`info/${payload.id}`, payload)
}

// 写广帖子
export function postInfo(payload) {
  return requestPost('info', payload)
}

// 获取话题
export function getTopic(payload) {
  return requestGet(`category/${payload.categoryID}/topic`, payload)
}

// 获取板块
export function getCategory(payload) {
  return requestGet('category', payload)
}

// 获取评论
export function getComment(payload) {
  return requestGet(`info/${payload.id}/comment`, payload)
}
// 发布评论
export function postComment(payload) {
  return requestPost(`info/${payload.id}/comment`, payload)
}

// 回复评论
export function postCommentReply(payload) {
  return requestPost(`comment/${payload.id}/reply`, payload)
}

// 浏览文章
export function postVisitInfo(payload) {
  return requestPost(`info/${payload.id}/visit`, payload)
}

// 收藏
export function postCollectInfo(payload) {
  return requestPost(`info/${payload.id}/collect`, payload)
}

// 点赞
export function postLikeInfo(payload) {
  return requestPost(`info/${payload.id}/like`, payload)
}

// 获取个人资料
export function getUser() {
  return requestGet('user/0')
}

// 更新个人资料
export function postUser(payload) {
  return requestPost('user/edit', payload)
}

//获取通知
export function getMessage(payload) {
  return requestGet('message', payload)
}

//更新通知查看时间
export function updateMessage(payload) {
  return requestPut(`message/${payload.id}`)
}

// 更改密码
export function putPassword(payload) {
  return requestPut('user/1', payload)
}

// 获取我的帖子
export function postMyInfo(payload) {
  return requestPost('user/info', payload)
}

// 删除我的帖子
export function delMyInfo(payload) {
  return requestDelete(`user/info/${payload.id}`, payload)
}

// 获取收藏的帖子
export function getUserCollect(payload) {
  return requestGet('userCollect', payload)
}

// 搜索
export function getSearch(payload) {
  return requestGet('search', payload)
}

//热门帖子
export function getHot(payload) {
  return requestGet('info', payload)
}

//获取帖子浏览量
export function getVisit(payload) {
  return requestGet('infoVisitUser', payload)
}

//首页：获取帝业人前十一条的帖子
export function getHomePageTopList(payload) {
  return requestGet('home/emperor', payload)
}
//首页：获取其他专题板块前四的帖子
export function getHomePageOtherList(payload) {
  return requestGet('home/others', payload)
}
//首页：获取内部心声的帖子数据共十二条
export function getHomePageVoiceList(payload) {
  return requestGet('info', payload)
}
//首页：获取top10的内部心声帖子数据
export function getHomePageTopTen(payload) {
  return requestGet('home/company', payload)
}
//首页：获取热门视频
export function getHotVideo(payload) {
  return requestGet('home/hotVideo', payload)
}
